import "./FAQ.scss";
const FAQ = (props) => {
    const faqs = [
        {
            q: "Warum lohnt es sich, eine Geschäftsadresse zu mieten?",
            a: "Eine gemietete Geschäftsadresse verleiht Ihrem Unternehmen sofort ein professionelles Erscheinungsbild und schafft Vertrauen bei Kunden und Partnern. Ideal für Gründer, Freiberufler oder internationale Firmen, die ohne teure Büroräume in einer renommierten Lage präsent sein möchten."
        },
        {
            q: "Wie läuft die Anmietung einer Geschäftsadresse bei CleverDomizil ab?",
            a: "Sie wählen einen unserer Standorte, etwa in Hamburg, Frankfurt am Main (Eschborn) oder Zürich. Wir übernehmen auf Wunsch die gesamte Abwicklung: Anmeldung, Registrierung und Handelsregistereintragung. Ihre Adresse ist innerhalb kürzester Zeit geschäftlich nutzbar."
        },
        {
            q: "Welche Vorteile habe ich durch eine Geschäftsadresse von CleverDomizil?",
            a: "Sie erhalten eine repräsentative, ladungsfähige Adresse in zentraler Lage, profitieren von Postservice, optionalen Büro- und Meetingräumen sowie auf Wunsch umfassender Gründungs- und Verwaltungsunterstützung."
        },
        {
            q: "Kann ich die Geschäftsadresse für eine GmbH, UG oder ein Einzelunternehmen verwenden?",
            a: "Ja, unsere Adressen sind offiziell ladungsfähig und können für alle Rechtsformen wie GmbH, UG oder Einzelunternehmen genutzt werden, auch für Handelsregistereintragungen."
        },
        {
            q: "Welche Vertragslaufzeiten bietet CleverDomizil an?",
            a: "Unsere Verträge sind flexible, ob kurzzeitig oder langfristig. Sie bestimmen die Laufzeit ganz nach dem Bedarf Ihres Unternehmens. Die Mindestlaufzeit beträgt jedoch 6 Monate."
        },
        {
            q: "Kann meine Post auch ins Ausland weitergeleitet werden?",
            a: "Ja, wir bieten internationalen Postversand. Ihre Post wird auf Wunsch weltweit an Ihre Zieladresse weitergeleitet und dies sicher und diskret."
        },
        {
            q: "Wie schnell kann ich meine neue Geschäftsadresse nutzen?",
            a: "In der Regel sofort nach Vertragsabschluss. Den genauen Leistungsbeginn legen Sie im Bestellformular individuell fest."
        },
        {
            q: "Wie schützt CleverDomizil meine persönlichen Daten?",
            a: "Datenschutz hat höchste Priorität. Alle Daten werden streng vertraulich behandelt und ausschließlich für die vereinbarten Zwecke verwendet."
        },
        {
            q: "Wie funktioniert die Postbearbeitung und -weiterleitung?",
            a: "Ihre Post wird täglich gescannt und digital in Ihrem sicheren App Postfach bereitgestellt. Originale werden nach Wunsch oder festgelegtem Rhythmus weitergeleitet."
        },
        {
            q: "Kann ein Firmenschild an der Adresse angebracht werden?",
            a: "Dauerhafte Schilder an unsere Gebäuden ist nicht gestattet. Ihr Firmenname erscheint jedoch am Briefkasten. Für Termine oder Meetings sind temporäre Beschilderungen möglich."
        },
        {
            q: "Darf die Geschäftsadresse auch als Wohnadresse verwendet werden?",
            a: "Nein. Unsere Geschäftsadressen dienen ausschließlich geschäftlichen Zwecken. Eine Meldeadresse oder Wohnungsgeberbescheinigung kann nicht ausgestellt werden."
        },
        {
            q: "Kann ich Konferenzräume auch außerhalb der Geschäftszeiten nutzen?",
            a: "Ja, nach Absprache stellen wir Ihnen unsere Konferenzräume bei Verfügbarkeit auch abends oder am Wochenende zur Verfügung."
        },
        {
            q: "Sind individuelle Getränke oder Catering-Optionen für Meetings möglich?",
            a: "Gerne! Wir richten uns nach Ihren Wünschen und bereiten Getränke oder Snacks nach Absprache vor."
        },
        {
            q: "Bietet CleverDomizil zusätzliche Unternehmensservices an?",
            a: "Ja. Wir unterstützen bei Unternehmensgründung, Buchhaltung, Personalwesen, steuerlichen und rechtlichen Themen, von der Idee bis zum laufenden Betrieb."
        },
        {
            q: "Was ist die CleverDomizil Firmenrufnummer?",
            a: "Die CleverDomizil Firmenrufnummer ist eine virtuelle Businessnummer, mit der Sie weltweit unter Ihrer lokalen Geschäftsnummer erreichbar sind. Es ist unabhängig von Ihrem Standort."
        },
        {
            q: "Wie funktioniert die CleverDomizil-Firmenrufnummer?",
            a: "Sie benötigen lediglich eine Internetverbindung. Ihre Anrufe werden über ein sicheres System auf Ihr Smartphone oder Tablet weitergeleitet. Ihre Kunden wählen eine lokale Nummer, Sie empfangen den Anruf überall auf der Welt."
        },
        {
            q: "Welche Vorteile bietet mir die Firmenrufnummer von CleverDomizil?",
            a: "Sie bleiben für internationale Kunden jederzeit unter einer lokalen Nummer erreichbar, sparen Roamingkosten, und präsentieren sich professionell mit einer geschäftlichen Rufnummer."
        }
    ]
    

    const handleDetails = (event) => {
        const detailsList = document.querySelectorAll("details");
        if (!event.target.open) return;
        for (let details of detailsList) {
            details.open = details === event.target;
        }
    }

    return (
        <div className={`faq ${props.className}`}>
            {faqs.map((f, idx) => (
                <details key={idx} onToggle={handleDetails}>
                    <summary >
                        <span className="faq-marker">+</span>
                        <h3>{f.q}</h3>
                    </summary>
                    <p>{f.a}</p>
                </details>
            ))}
        </div>
    )
}
export default FAQ;